import { render, staticRenderFns } from "./ProFolderEditForm.vue?vue&type=template&id=27f63b30&"
import script from "./ProFolderEditForm.vue?vue&type=script&lang=ts&"
export * from "./ProFolderEditForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports